import { forEach } from "lodash";
import moment from "moment";
import { element } from "prop-types";
import React, { useState } from "react";

import { useEffect } from "react";

import { GetRequest } from "../../../lib/Board";

const ManagementTab3 = props => {
    const [showStep, setShowStep] = useState(1);

    const [search, setSearch] = useState({
        password: "1234qwer!@#$",
        requestID: "221219175816677"
    });

    const [data, setData] = useState({});

    const clickGet = () => {
        GetRequest(
            search,
            res => {
                console.log("Res", res);
                setShowStep(2);
                setData(res);
            },
            res => {
                alert("등록된 정보가 없습니다.");
            }
        );
    };

    return (
        <>
            <section id="tab3" className="tab-cont">
                {showStep === 1 && (
                    <>
                        <p className="process-confirm-text">
                            온라인 제보에 대한 접수 현황 및 저리상태를 확인하실 수 있습니다.
                            <br />
                            <b>※ 제보 접수 시 발급받으신 접수번호와 설정하신 비밀번호를 입력해 주세요</b>
                        </p>
                        <div className="process-confirm-wrap">
                            <div className="cols">
                                <label htmlFor="number" className="import">
                                    접수번호
                                </label>
                                <input
                                    type="number"
                                    className="text_nor lg"
                                    id="number"
                                    placeholder="접수번호"
                                    value={search.requestID}
                                    onChange={e => {
                                        search.requestID = e.target.value;
                                        setSearch({ ...search });
                                    }}
                                />
                            </div>
                            {/* <div className="cols">
                                <label htmlFor="pwd" className="import">
                                    비밀번호
                                </label>
                                <input
                                    type="password"
                                    className="text_nor lg"
                                    id="pwd"
                                    placeholder="비밀번호"
                                    value={search.password}
                                    onChange={e => {
                                        search.password = e.target.value;
                                        setSearch({ ...search });
                                    }}
                                />
                            </div> */}
                        </div>
                        <div className="board-detail-btns">
                            <button type="button" className="btn_nor red-line wide lg" onClick={clickGet}>
                                확인하기
                            </button>
                        </div>{" "}
                    </>
                )}

                {showStep === 2 && (
                    <>
                        <p className="ethical-process-text">
                            {data.name}님께서 {moment(data.createdAt).format("YYYY년 MM월 DD일")} 신청하신 민원이 {data.answer !== null && data.answer !== "" ? "처리되었습니다." : "접수되었습니다."}
                        </p>

                        <table className="tbl_normal wAuto">
                            <colgroup>
                                <col width="15%" />
                                <col width="auto" />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th>신청번호</th>
                                    <td className="textL">{data.requestID}</td>
                                </tr>
                                <tr>
                                    <th>민원제목</th>
                                    <td className="textL">{data.title}</td>
                                </tr>
                            </tbody>
                        </table>
                        {/* <p className="ethical-txt-sm">* 민원처리에 대한 답변은 **** 처리됩니다.</p> */}

                        <div className="board-detail-btns">
                            <button
                                type="button"
                                className="btn_nor red-line wide lg"
                                onClick={() => {
                                    setShowStep(3);
                                }}
                            >
                                내 민원보기
                            </button>
                        </div>
                    </>
                )}

                {/* ----------------- 내 민원보기 누르면 나오는 화면 --------------- */}
                {showStep === 3 && (
                    <>
                        <table className="tbl_upload">
                            <colgroup>
                                <col width="15%" />
                                <col width="auto" />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th>이름</th>
                                    <td>{data.name}</td>
                                </tr>
                                <tr>
                                    <th>핸드폰</th>
                                    <td>{data.phone}</td>
                                </tr>
                                <tr>
                                    <th>제목</th>
                                    <td>{data.title}</td>
                                </tr>
                                <tr>
                                    <th>내용</th>
                                    <td>{data.contents}</td>
                                </tr>
                                <tr>
                                    <th>첨부파일</th>
                                    {data.uploadFiles.length === 0 ? (
                                        <td>첨부파일 없음</td>
                                    ) : (
                                        <td>
                                            {data.uploadFiles.map(x => {
                                                return [<a href={x.url}>{x.originalname}</a>, <br />];
                                            })}
                                        </td>
                                    )}
                                </tr>
                                {data.answer !== null && data.answer !== "" && (
                                    <tr>
                                        <th>처리결과</th>
                                        <td>
                                            <p style={{ whiteSpace: "pre-line" }}>{data.answer}</p>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </>
                )}
            </section>
        </>
    );
};

export default ManagementTab3;
